import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getCauses,
  deleteCause,
  getNextCauses,
  getPreviousCauses,
} from "../../store/actions/causes_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/causes_enum";
import DataTable from "../../components/common/DataTable";
const AllCauses = ({
  getCauses,
  deleteCause,
  getNextCauses,
  getPreviousCauses,
  cause: { loading, causes },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteCause(deleteEntry);
      }
      getCauses({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (causes && causes.length === LIMIT) {
      const lastCause = causes[causes.length - 1];
      getNextCauses({ last: lastCause });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastCause = causes[0];
      getPreviousCauses({
        first: lastCause,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getCauses({ term: term, termField: termField });
    }
  };
  const deleteCauseClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getCauses({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Causes"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Cause"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="causes" title="Cause" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={causes}
                      field={"causes"}
                      page={page}
                      deleteBtnClicked={deleteCauseClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={causes}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ cause: state.cause });

const mapDispatchToProps = {
  getCauses,
  deleteCause,
  getNextCauses,
  getPreviousCauses,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllCauses);
